import {
  Box,
  Collapse,
  Group,
  Menu,
  ThemeIcon,
  UnstyledButton,
  createStyles,
  rem,
} from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

interface LinksGroupProps {
  icon: React.FC<any>;
  label: string;
  initiallyOpened?: boolean;
  active?: boolean;
  links?: { label: string; link: string; Icon?: React.FC<any>,active?:boolean }[];
  collapse: boolean;
  link?: string;
}

export function LinkDropDown({
  icon: Icon,
  label,
  initiallyOpened,
  links,
  collapse,
  link,
  active
}: LinksGroupProps) {
  const useStyles = createStyles((theme) => ({
    control: {
      fontWeight: 500,
      display: "block",
      width: "100%",
      padding: `${theme.spacing.xs} ${theme.spacing.md}`,
      color: theme.colors.dark[0],
      //   color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      fontSize: theme.fontSizes.sm,

      "&:hover": {
        backgroundColor: theme.colors.dark[7],
        // "&:hover": {
        //     backgroundColor:
        //       theme.colorScheme === "dark"
        //         ? theme.colors.dark[7]
        //         : theme.colors.gray[0],
        color: theme.white,
        // color: theme.colorScheme === "dark" ? theme.white : theme.black,
      },
    },

    link: {
      fontWeight: 500,
      display: "block",
      textDecoration: "none",
      cursor: "pointer",
      padding: `${theme.spacing.xs} ${theme.spacing.md}`,
      paddingLeft: collapse ? rem(8) : rem(31),
      marginLeft: collapse ? rem(8) : rem(30),
      fontSize: theme.fontSizes.sm,
      color: theme.colors.dark[0],
      //   color:
      //     theme.colorScheme === "dark"
      //       ? theme.colors.dark[0]
      //       : theme.colors.gray[7],
      borderLeft: `${rem(1)} solid ${theme.colors.dark[4]}`,
      //   borderLeft: `${rem(1)} solid ${
      //     theme.colorScheme === "dark"
      //       ? theme.colors.dark[4]
      //       : theme.colors.gray[3]
      //   }`,

      "&:hover": {
        backgroundColor: theme.colors.dark[7],
        // "&:hover": {
        //     backgroundColor:
        //       theme.colorScheme === "dark"
        //         ? theme.colors.dark[7]
        //         : theme.colors.gray[0],
        color: theme.white,
        // color: theme.colorScheme === "dark" ? theme.white : theme.black,
      },
    },

    chevron: {
      transition: "transform 200ms ease",
    },
  }));

  const { classes, theme } = useStyles();
  const navigate = useNavigate();
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);
  const ChevronIcon = theme.dir === "ltr" ? IconChevronRight : IconChevronLeft;
  const items = (hasLinks ? links : []).map((link) => (
    <NavLink className={`${classes.link} ${link?.active ? 'bg-primary text-white':''}`} to={link.link} key={link.label} >
      {collapse ? (
        link.Icon ? (
          <div className="flex space-x-2 text-sm">
            {/* <div>{link.Icon && (
              <ThemeIcon variant="light" size={16}>
                <link.Icon size="1.1rem" />
              </ThemeIcon>
            )}</div> */}
            <div> {link.label}</div>
          </div>
        ) : (
          link.label
        )
      ) : (
        link.label
      )}
    </NavLink>
  ));

  return (
    <>
      {!collapse && (
        <UnstyledButton
          onClick={() => {
            setOpened((o) => !o);
            if (link) {
              navigate(link);
            }
          }}
          className={`${classes.control} ${active ? 'bg-primary text-white':''}`}
        >
          <Group position="apart" spacing={0}>
            {link ? (
              <NavLink to={link} >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ThemeIcon variant="dark" className="text-gray-400" size={30}>
                    <Icon size="1.1rem" />
                  </ThemeIcon>
                  {!collapse && <Box ml="md">{label}</Box>}
                </Box>
              </NavLink>
            ) : (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <ThemeIcon variant="dark" className="text-gray-400" size={30}>
                  <Icon size="1.1rem" />
                </ThemeIcon>
                {!collapse && <Box ml="md">{label}</Box>}
              </Box>
            )}
            {hasLinks && !collapse && (
              <ChevronIcon
                className={classes.chevron}
                size="1rem"
                stroke={1.5}
                style={{
                  transform: opened
                    ? `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
                    : "none",
                }}
              />
            )}
          </Group>
        </UnstyledButton>
      )}
      {hasLinks ? (
        !collapse ? (
          <Collapse in={opened}>{items}</Collapse>
        ) : (
          <Menu
            trigger="hover"
            position="right-start"
            transitionProps={{ duration: 150 }}
          >
            <Menu.Target>
              <UnstyledButton
                onClick={() => setOpened((o) => !o)}
                className={classes.control}
              >
                <Group position="apart" spacing={0}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <ThemeIcon variant="light" size={30}>
                      <Icon size="1.1rem" />
                    </ThemeIcon>
                    {!collapse && <Box ml="md">{label}</Box>}
                  </Box>
                  {hasLinks && !collapse && (
                    <ChevronIcon
                      className={classes.chevron}
                      size="1rem"
                      stroke={1.5}
                      style={{
                        transform: opened
                          ? `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
                          : "none",
                      }}
                    />
                  )}
                </Group>
              </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown className="bg-gray-900 hover:bg-gray-900 text-white">
              {items?.map((item) => (
                <Menu.Item className="text-xs bg-gray-900" key={item.key}>
                  {item}
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        )
      ) : (
        collapse && (
          <NavLink
            to={!hasLinks && link ? link : ""}
            className={`${classes.control} ${active ? 'bg-primary text-white':''}`}
          >
            <Group position="apart" spacing={0}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <ThemeIcon variant="light" size={30}>
                  <Icon size="1.1rem" />
                </ThemeIcon>
              </Box>
            </Group>
          </NavLink>
        )
      )}
    </>
  );
}
